import { inject,Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { GraphDotnetService, graphql, StoreEnvironment } from 'app/shared/graph';
import { DesignerBranch } from 'app/shared/graph';

@Injectable({ providedIn: 'root' })
export class DesignerReleaseChannelService {
    private readonly graphDotnetService = inject(GraphDotnetService);


    public getDesignerReleaseChannels(storeEnvironment: StoreEnvironment): Observable<DesignerBranch[]> {
        return this.graphDotnetService.query(graphql`
                query designerReleaseChannels($storeEnvironment: StoreEnvironment) {
                    designerReleaseChannels(storeEnvironment: $storeEnvironment) {
                        id
                    }
                }
            `,
            {
                storeEnvironment: storeEnvironment
            }
        ).pipe(map((q) => q.designerReleaseChannels));
    }
}
